var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeloVerificado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_224_2474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7601 4.0081C13.1301 4.42436 12.5661 5.05553 12.6708 5.56727C12.7455 5.93255 13.3397 6.26816 13.3688 6.69067C13.4118 7.31299 12.5664 7.49979 12.6715 8.27196C12.7179 8.61226 13.0022 9.00094 12.8483 9.3467C12.6596 9.77025 11.8277 9.78456 11.6769 10.2836C11.579 10.608 11.6657 11.0432 11.5074 11.337C11.2681 11.7813 10.5109 11.5154 10.1302 11.7561C9.82533 11.9489 9.74461 12.4422 9.52485 12.7122C9.13376 13.193 8.45365 12.5964 7.97117 12.6688C7.54544 12.7328 7.19706 13.3808 6.74113 13.3931C6.27115 13.4056 5.91963 12.7341 5.48506 12.6688C5.01898 12.5988 4.37063 13.1589 3.96834 12.7531C3.66995 12.452 3.63532 11.8336 3.18174 11.6918C2.67139 11.5324 2.01966 11.8193 1.87046 11.1028C1.77074 10.6244 1.95352 10.2344 1.46609 9.91985C1.22108 9.76167 0.724531 9.62794 0.603975 9.35035C0.401139 8.88283 0.983609 8.33726 0.727135 7.79637C0.531329 7.38349 -0.0896776 7.06297 0.127479 6.5226C0.241786 6.23798 0.514404 6.04208 0.671674 5.7918C1.0487 5.19159 0.397233 4.65773 0.597986 4.15717C0.776086 3.71255 1.61685 3.7253 1.77308 3.19794C1.86838 2.8769 1.79678 2.4804 1.93191 2.1859C2.15975 1.68924 2.94818 1.98765 3.34135 1.72098C3.69547 1.48059 3.76681 0.737813 4.15712 0.610852C4.51879 0.493257 4.97237 0.803895 5.3356 0.824968C6.00816 0.863993 6.30708 -0.213614 7.05437 0.20005C7.32152 0.347824 7.65793 0.770333 7.94487 0.818984C8.38647 0.893912 9.02232 0.395174 9.39675 0.669389C9.74279 0.922791 9.78263 1.51207 10.1302 1.73165C10.4778 1.95123 11.1363 1.75038 11.429 2.04697C11.7313 2.3537 11.517 2.99944 11.7417 3.34754C11.9456 3.66364 12.5197 3.73779 12.7601 4.0081Z",
    fill: "url(#paint0_linear_224_2474)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_224_2474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.90318 3.73269C9.82181 3.67301 9.75315 3.64622 9.65014 3.66737C9.60358 3.677 9.55185 3.71389 9.51469 3.74373L5.64696 7.60923L3.94296 5.90522C3.84513 5.82792 3.70427 5.82698 3.6008 5.89418C3.52155 5.94564 2.84639 6.62165 2.78949 6.70483C2.7234 6.80117 2.70177 6.91231 2.76174 7.01522L5.46964 9.73712C5.54913 9.80126 5.67659 9.81536 5.77042 9.77706L10.7117 4.84574C10.7571 4.74236 10.7578 4.61547 10.6912 4.51984C10.611 4.40447 10.0222 3.8201 9.90318 3.73293V3.73269Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_224_2474",
    x1: 9.82065,
    y1: 1.09398,
    x2: 3.08487,
    y2: 12.0909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1386ED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_224_2474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.2882,
    height: 13.2882,
    fill: "white",
    transform: "translate(0.0820312 0.105331)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_224_2474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.87688,
    height: 6.79605,
    fill: "white",
    transform: "translate(2.2959 3.33136)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeloVerificado);
export default __webpack_public_path__ + "static/media/selo-verificado.f3b4a650.svg";
export { ForwardRef as ReactComponent };